import React from 'react'
import { ActionIcon } from '@mantine/core'

function Icon({ width, height, color = 'currentColor' }) {
  return (
    <svg
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 16 16"
      className="design-iconfont"
    >
      <defs>
        <path
          id="1o2wx00j7__4i7ftbk1ia"
          d="M0 0L5.56958485 0 5.56958485 15.9996195 0 15.9996195z"
        />
        <path
          id="1o2wx00j7__wvxsrbpkkc"
          d="M0 0L5.56957586 0 5.56957586 15.9996195 0 15.9996195z"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g transform="translate(2)">
          <mask id="1o2wx00j7__0x7uzp6j2b" fill="#fff">
            <use xlinkHref="#1o2wx00j7__4i7ftbk1ia" />
          </mask>
          <path
            d="M5.56958485,8.00070859 L5.56958485,7.9993004 L5.56958485,5.93744774 L5.56958485,4.43919871 L4.80182435,5.14257219 L1.42292911,1.64449056 C1.21104219,1.42133816 1.12088839,1.15045728 1.12852854,0.88733639 L1.12852854,0 C-0.012371056,0.494692434 -0.434407131,2.06925312 0.553539591,3.06019598 L5.56886578,7.99998951 L0.549584688,12.9437679 C-0.433298559,13.9355197 -0.0106332957,15.5052866 1.12771958,15.9996195 L1.12771958,15.0869058 L1.12822892,15.0869058 C1.12688066,14.8263316 1.22164852,14.5602146 1.43548293,14.3425152 L5.56958485,10.0625612 L5.56958485,8.00070859 Z"
            fill="#00A870"
            mask="url(#1o2wx00j7__0x7uzp6j2b)"
          />
        </g>
        <g transform="translate(8.801001 .000381)">
          <mask id="1o2wx00j7__3soizdtutd" fill="#fff">
            <use xlinkHref="#1o2wx00j7__wvxsrbpkkc" />
          </mask>
          <path
            d="M5.01604526,12.9394235 L0.000719073249,7.99960002 L5.02000016,3.05585158 C6.00288341,2.06409976 5.58021815,0.494332898 4.44186527,0 L4.44186527,0.912713683 L4.44135592,0.912713683 C4.44270419,1.17328785 4.34793633,1.43940488 4.13410192,1.6571043 L0.794875554,5.11413883 L0,4.43880921 L0,7.9989109 L0,8.00031909 L0,10.0621717 L4.14665574,14.3551289 C4.35854266,14.5782813 4.44869646,14.8491622 4.44105631,15.1122531 L4.44105631,15.9996195 C5.58195591,15.5049271 6.00399198,13.9303664 5.01604526,12.9394235"
            fill="#00A870"
            mask="url(#1o2wx00j7__3soizdtutd)"
          />
        </g>
        <path
          d="M9.37279323,14.4569197 L2.99778941,14.4569197 C2.14556777,14.4569197 1.45471814,15.1477993 1.45471814,15.999991 L10.9158945,15.999991 C10.9158945,15.1477993 10.2250149,14.4569197 9.37279323,14.4569197"
          fill="#00A870"
          transform="translate(2)"
        />
        <path
          d="M2.99779241,1.54308026 L9.37279622,1.54308026 C10.2250179,1.54308026 10.9158675,0.852200673 10.9158675,8.98841563e-06 L1.45469118,8.98841563e-06 C1.45469118,0.852200673 2.14557076,1.54308026 2.99779241,1.54308026"
          fill="#00A870"
          transform="translate(2)"
        />
        <path
          d="M6.15414047,2.37401134 C5.95127193,2.37401134 5.78678392,2.53846939 5.78678392,2.74133793 C5.78678392,2.94423643 5.95127193,3.10869448 6.15414047,3.10869448 C6.35700901,3.10869448 6.52146705,2.94423643 6.52146705,2.74133793 C6.52146705,2.53846939 6.35700901,2.37401134 6.15414047,2.37401134"
          fill="#00A870"
          transform="translate(2)"
        />
        <path
          d="M4.84170595,3.7684292 C4.84170595,3.97129774 5.00616399,4.13575579 5.20903253,4.13575579 C5.41193104,4.13575579 5.57638908,3.97129774 5.57638908,3.7684292 C5.57638908,3.56556066 5.41193104,3.40107266 5.20903253,3.40107266 C5.00616399,3.40107266 4.84170595,3.56556066 4.84170595,3.7684292"
          fill="#00A870"
          transform="translate(2)"
        />
        <path
          d="M7.15550689,4.13576477 C7.35837543,4.13576477 7.52283348,3.97130673 7.52283348,3.76843819 C7.52283348,3.56553969 7.35837543,3.40108164 7.15550689,3.40108164 C6.95263835,3.40108164 6.78815035,3.56553969 6.78815035,3.76843819 C6.78815035,3.97130673 6.95263835,4.13576477 7.15550689,4.13576477"
          fill="#00A870"
          transform="translate(2)"
        />
        <path
          d="M7.05738635,12.952999 C7.26025489,12.952999 7.4247429,12.788541 7.4247429,12.5856425 C7.4247429,12.3827739 7.26025489,12.2183159 7.05738635,12.2183159 C6.85451781,12.2183159 6.69005977,12.3827739 6.69005977,12.5856425 C6.69005977,12.788541 6.85451781,12.952999 7.05738635,12.952999"
          fill="#00A870"
          transform="translate(2)"
        />
        <path
          d="M6.11229939,13.2453862 C5.90943085,13.2453862 5.74494285,13.4098442 5.74494285,13.6127427 C5.74494285,13.8155813 5.90943085,13.9800693 6.11229939,13.9800693 C6.31516793,13.9800693 6.47965594,13.8155813 6.47965594,13.6127427 C6.47965594,13.4098442 6.31516793,13.2453862 6.11229939,13.2453862"
          fill="#00A870"
          transform="translate(2)"
        />
        <path
          d="M5.23328028,12.2183009 C5.03041174,12.2183009 4.8659537,12.3827589 4.8659537,12.5856574 C4.8659537,12.788526 5.03041174,12.952984 5.23328028,12.952984 C5.43614882,12.952984 5.60063683,12.788526 5.60063683,12.5856574 C5.60063683,12.3827589 5.43614882,12.2183009 5.23328028,12.2183009"
          fill="#00A870"
          transform="translate(2)"
        />
        <path
          d="M3.92084576,13.6127337 C3.92084576,13.8156023 4.08530381,13.9800603 4.28820231,13.9800603 C4.49107085,13.9800603 4.6555289,13.8156023 4.6555289,13.6127337 C4.6555289,13.4098652 4.49107085,13.2453772 4.28820231,13.2453772 C4.08530381,13.2453772 3.92084576,13.4098652 3.92084576,13.6127337"
          fill="#00A870"
          transform="translate(2)"
        />
        <path
          d="M8.42610034,13.6127337 C8.42610034,13.4098652 8.26164229,13.2453772 8.05874379,13.2453772 C7.85587525,13.2453772 7.69141721,13.4098652 7.69141721,13.6127337 C7.69141721,13.8156023 7.85587525,13.9800603 8.05874379,13.9800603 C8.26164229,13.9800603 8.42610034,13.8156023 8.42610034,13.6127337"
          fill="#00A870"
          transform="translate(2)"
        />
      </g>
    </svg>
  )
}

const cyljsy = (props) => {
  const {
    fill = 'blue',
    variant = 'transparent',
    size = 'lg',
    radius = 'lg',
    width = 20,
    height = 20,
    loading = false,
    disabled = false,
  } = props
  return (
    <ActionIcon
      color={fill}
      variant={variant}
      size={size}
      radius={radius}
      loading={loading}
      disabled={disabled}
    >
      <Icon width={width} height={height} />
    </ActionIcon>
  )
}

export default cyljsy
